enum MovieEditorMode {
  Select = 'select',
  Drag = 'drag',
  CreateShape = 'create-shape',
  CreateText = 'create-text',
  EditText = 'edit-text',
  EditPath = 'edit-path',
  CreateMask = 'create-mask',
  EditMask = 'edit-mask',
  EditGradient = 'edit-gradient',
}

enum MoviePenToolCursorMode {
  Default = 'default',
  Grab = 'grab',
  AddPoint = 'add-point',
  ToggleCurve = 'toggle-curve',
  ClosePath = 'close-path',
}

enum AnimationFunction {
  Linear = 'linear',
  Ease = 'ease',
  EaseIn = 'ease-in',
  EaseOut = 'ease-out',
}

enum MovieEditorDragType {
  Asset = 'CL_ASSET',
  Mask = 'CL_MASK',
}

enum LayerViewMode {
  Open = 'open',
  Closed = 'closed',
  Position = 'position',
  Scale = 'scale',
  Opacity = 'opacity',
  Keyframe = 'keyframe',
}

enum MovieCopyPart {
  Layer = 'layer-copy',
  Property = 'prop-copy',
  Mask = 'mask-copy',
  Effect = 'effect-copy',
  Shape = 'shape',
  Animator = 'animator-copy',
  Transform = 'transform-copy',
  MasksList = 'all-masks-copy',
  EffectsList = 'all-effects-copy',
  ShapesList = 'all-shapes-list',
  Animators = 'all-animators-copy',
}

enum KeyframeType {
  Hold = 'hold',
  Linear = 'linear',
  Ease = 'ease',
  EaseIn = 'easeIn',
  EaseOut = 'easeOut',
  Custom = 'custom',
}

export {
  MovieEditorMode,
  AnimationFunction,
  MovieEditorDragType,
  LayerViewMode,
  MovieCopyPart,
  MoviePenToolCursorMode,
  KeyframeType,
};
